import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

export const Header = styled.div``

export const Title = styled.h2`
  font: normal normal bold 16px Inter;
`

export const BehaviorsLastUpdate = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`
